import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';

/**
 * Service to change user password.
 */
@Injectable()
export class ChangePasswordService {
    constructor(private requestService: ObservableRequestService) { }

    changePassword(body: Object): Observable<any> {
        const changePasswordUrl = ConstantsService.CHANGE_PASSWORD_URL;
        return this.requestService
            .postRequest(changePasswordUrl,
            this.requestService.serialize(body),
            this.requestService.getFormEncodedContentType());
    };
}



// WEBPACK FOOTER //
// ./src/app/header/usersettings/changepassword/change-password.service.ts